<div>

  <div class="sidebar-wrapper">
    <div
      class="app-logo backdrop-blur-md scale-up"
      matRipple
      routerLink="{{ homeLink }}"
      style="--order: 3"
    >
      <img [src]="imageUrl" alt="Emblem" />
    </div>

    <div class="flex sb-module-name text-white justify-content-center pl-2">
      {{ menuData.moduleName | uppercase }}
    </div>

    <mat-divider class="mb-2" style="border-top-color: #F8F9FA;"></mat-divider>

    <ng-container *ngFor="let menu of menuData.menuItems; let i = index">
      <!--   if user type is provided, then we check user type; if not provided, then we dont check   -->
      <ng-container *ngIf="!userType || !menu.userType || menu.userType.includes(userType)">
        <ng-container  *ngxPermissionsOnly="menu.permission">
          <div class="flex items-center mt-2" *ngIf="isNavigated(menu.route); else inActiveRoute">

            <div style="height: 40px; padding-left: 1.4rem"
                 class="grow text-primary-500 flex items-center bg-gray-50 mr-2 rounded-r-full shadow">
            <span *ngIf="menu.iconType === 'MATERIAL'" class="intro-x" [style]="{'--order': i/8, 'opacity': 0}">
              <mat-icon>{{ menu.icon }}</mat-icon>
            </span>
              <span *ngIf="menu.iconType === 'SVG'" class="intro-x" [style]="{'--order': i/8, 'opacity': 0}">
              <mat-icon svgIcon="{{ menu.icon }}"></mat-icon>
            </span>
              <span *ngIf="menu.iconType === 'FA'" class="intro-x" [style]="{'--order': i/8, 'opacity': 0}">
              <app-font-awesome-icon [iconName]="menu.icon"></app-font-awesome-icon>
            </span>
              <span class="ml-2 font-medium intro-x" [style]="{'--order': i/8, 'opacity': 0}">
              {{ menu.name }}
            </span>
            </div>
            <svg width="20" height="50" viewBox="0 0 20 50" fill="none" xmlns="http://www.w3.org/2000/svg"
                 class="intro-x" [style]="{'--order': i/8, 'opacity': 0}">
              <path d="M20 0V50C14.1227 35.8696 0.448504 35.413 0.00952148 24C-0.429461 12.587 14.5 13.5 20 0Z" fill="#F8F9FA"/>
              <path d="M12.4348 19L7 24.4348L12.4348 29.8696" stroke="#0F2167" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
          <ng-template #inActiveRoute>
            <div class="flex items-center cursor-pointer mt-2 intro-x" [style]="{'--order': i/8, 'opacity': 0}" [routerLink]="menu.route">
              <div style="height: 40px; padding-left: 1.4rem" class="grow text-white flex items-center mr-2 rounded-r-full">
          <span *ngIf="menu.iconType === 'MATERIAL'">
            <mat-icon>{{ menu.icon }}</mat-icon>
          </span>
                <span *ngIf="menu.iconType === 'SVG'">
            <mat-icon svgIcon="{{ menu.icon }}"></mat-icon>
          </span>
                <span *ngIf="menu.iconType === 'FA'" class="intro-x" [style]="{'--order': i/8, 'opacity': 0}">
            <app-font-awesome-icon [iconName]="menu.icon"></app-font-awesome-icon>
          </span>
                <span class="ml-2 font-medium">
            {{ menu.name }}
          </span>
              </div>
            </div>
          </ng-template>
        </ng-container>
      </ng-container>

    </ng-container>
  </div>


</div>
